import React from "react";
import { Link } from "react-router-dom";

const APP_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/ibnmxdi0_Gemini_Generated_Image_9w65679w65679w65.jpg";

function PhoneScene() {
  return (
    <div className="relative w-full aspect-[843/1264] overflow-hidden rounded-sm" data-testid="two-sides-app-stage">
      <img
        src={APP_IMAGE}
        alt="The Ask Kimberley app — Ask me a question. Available 24 hours. How can I help?"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="two-sides-app-image"
      />
    </div>
  );
}

function Caption({ a, b }) {
  return (
    <div className="grid grid-cols-2 border-t border-[#1F1B18]/15 mt-6 pt-5 text-left">
      <div className="pr-4 border-r border-[#1F1B18]/15">
        <p className="font-typewriter text-xs tracking-[0.35em] uppercase text-[#8B6B4A]">{a[0]}</p>
        <p className="font-cormorant text-2xl sm:text-3xl mt-1 text-[#1F1B18]">{a[1]}</p>
      </div>
      <div className="pl-6">
        <p className="font-typewriter text-xs tracking-[0.35em] uppercase text-[#8B6B4A]">{b[0]}</p>
        <p className={`font-cormorant text-2xl sm:text-3xl mt-1 ${b[2] || "text-[#1F1B18]"}`}>{b[1]}</p>
      </div>
    </div>
  );
}

function Side({ eyebrow, children, cta, to, onClick, testid }) {
  const cls =
    "inline-flex items-center gap-3 font-typewriter text-base sm:text-lg tracking-[0.25em] uppercase text-[#1F1B18] border-b border-[#1F1B18] pb-1 hover:text-[#D9739A] hover:border-[#D9739A] transition";
  return (
    <div className="h-full flex flex-col items-center text-center px-6 py-16 sm:py-20" data-testid={testid}>
      <p className="font-typewriter text-base sm:text-xl tracking-[0.4em] uppercase text-[#8B6B4A]">{eyebrow}</p>
      <div className="mt-12 flex-1 flex items-center justify-center w-full">{children}</div>
      {to ? (
        <Link to={to} className={`${cls} mt-14`} data-testid={`${testid}-cta`}>
          {cta} <span aria-hidden>⟶</span>
        </Link>
      ) : (
        <button type="button" onClick={onClick} className={`${cls} mt-14`} data-testid={`${testid}-cta`}>
          {cta} <span aria-hidden>⟶</span>
        </button>
      )}
    </div>
  );
}

export default function TwoSides() {
  return (
    <section className="w-full bg-[#F8F2E8] pt-24 sm:pt-32" data-testid="two-sides-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 flex items-center justify-between font-typewriter text-sm sm:text-base tracking-[0.4em] uppercase text-[#1F1B18]/55 border-b border-[#1F1B18]/15 pb-6">
        <span>No. 02</span>
        <span>The Collection</span>
      </div>
      <h2
        className="font-cormorant text-center leading-none tracking-tight text-[#1F1B18] px-6 mt-14 sm:mt-20"
        style={{ fontSize: "clamp(3rem, 6vw, 6.5rem)" }}
        data-testid="two-sides-heading"
      >
        One brand. <span className="italic text-[#D9739A]">Two sides.</span>
      </h2>

      <div className="mt-16 sm:mt-24 grid grid-cols-1 md:grid-cols-2 border-t border-[#1F1B18]/15">
        <div className="md:border-r border-b md:border-b-0 border-[#1F1B18]/15 bg-[#F5EBE2]">
          <Side eyebrow="Physical" cta="View Products" to="/products" testid="two-sides-physical">
            <div className="w-full max-w-[520px]">
              <div className="relative w-full aspect-[848/1264] overflow-hidden rounded-sm" data-testid="two-sides-product-stage">
                <img
                  src="/products/physical-scene.jpg"
                  alt="Peace Chews and Off Duty — Ask Kimberley for dog ppl"
                  className="absolute inset-0 w-full h-full object-cover scale-[1.22] origin-[50%_58%]"
                  data-testid="two-sides-products-image"
                />
              </div>
              <Caption a={["No. 01", "Peace Chews"]} b={["No. 02", "Off Duty"]} />
            </div>
          </Side>
        </div>
        <div className="bg-[#F8F2E8]">
          <Side eyebrow="Digital" cta="See the App" to="/the-app" testid="two-sides-digital">
            <div className="w-full max-w-[520px]">
              <PhoneScene />
              <Caption a={["No. 03", "The App"]} b={["Support", "Always on.", "italic text-[#D9739A]"]} />
            </div>
          </Side>
        </div>
      </div>
    </section>
  );
}
